export const SET_TEAMS = (state, team) => {
  state.teams = team;
};

export const SET_TEAM_LOADER = (state, loader) => {
  state.teamLoader = loader;
};